import xs from "xstream";
import { dumper, nopListener } from "../utils";

const PHOTO_WIDTH = 640

const _getShort = isBigEndian => {
	if (isBigEndian) {
        return (bytes, idx) => {
            return bytes.charCodeAt(idx) * 256 + bytes.charCodeAt(idx + 1);
        };
	} else {
        return (bytes, idx) => {
            return bytes.charCodeAt(idx) + bytes.charCodeAt(idx + 1) * 256;
        };
	}
}

const getOrientation = imgSrc => {
    let orientation = 1;

    if (!imgSrc.split(",")[0].match("jpeg")) {
        return orientation;
    }
    const img = atob(imgSrc.split(",")[1]);

    for (let head = 0; head < img.length; ) {
        if (img.charCodeAt(head) === 255 && img.charCodeAt(head + 1) === 218) {
            break;
        }
        if (img.charCodeAt(head) === 255 && img.charCodeAt(head + 1) === 216) {
			head += 2;
		} else {
            const length = img.charCodeAt(head + 2) * 256 + img.charCodeAt(head + 3);
            const endPoint = head + length + 2;
            if (img.charCodeAt(head) === 0xFF && img.charCodeAt(head + 1) === 0xE1) { // Exif Chunk
                const segment = img.slice(head, endPoint);
                const bigEndian = segment.charCodeAt(10) === 0x4D;
                const getShort = _getShort(bigEndian);
                const count = getShort(segment, 18);
                for (let i = 0; i < count; i++) {
                    const tagH = 20 + 12 * i;
                    if (getShort(segment, tagH) === 274) { // ORIENTATION = 274
                        orientation = getShort(segment, tagH + 8);
					}
				}
            }
            head = endPoint;
        }
    }
    return orientation;
}

const transformCoordinate = (canvas, width, height, orientation) => {
    if (orientation <= 4) {
		canvas.width = width;
		canvas.height = height;
	} else {
		canvas.width = height;
		canvas.height = width;
	}
    const ctx = canvas.getContext("2d");
    switch (orientation) {
        case 2: // horizontal flip
            ctx.translate(width, 0);
            ctx.scale(-1, 1);
            break;
		case 3: // 180 rotate left
            ctx.translate(width, height);
            ctx.rotate(Math.PI);
            break;
		case 4: // vertical flip
            ctx.translate(0, height);
            ctx.scale(1, -1);
            break;
		case 5: // vertical flip + 90 rotate right
            ctx.rotate(0.5 * Math.PI);
            ctx.scale(1, -1);
            break;
		case 6: // 90 rotate right
            ctx.rotate(0.5 * Math.PI);
            ctx.translate(0, -height);
            break;
		case 7: // horizontal flip + 90 rotate right
            ctx.rotate(0.5 * Math.PI);
            ctx.translate(width, -height);
            ctx.scale(-1, 1);
            break;
		case 8: // 90 rotate left
            ctx.rotate(-0.5 * Math.PI);
            ctx.translate(-width, 0);
            break;
	}
}

const detectSubsampling = img => {
    const iw = img.naturalWidth
    const ih = img.naturalHeight;
    if (iw * ih > 1024 * 1024) {
        const canvas = document.createElement("canvas");
        canvas.width = canvas.height = 1;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, -iw + 1, 0);
        return ctx.getImageData(0, 0, 1, 1).data[3] === 0;
	} else {
		return false;
	}
}
//
// frameWidthに収まるように中心から切り出す
const onResizeImage = (img: any, frameWidth: number) => {
    let iw = img.naturalWidth
    let ih = img.naturalHeight
    if (iw <= frameWidth || ih <= frameWidth) {
        frameWidth = (iw > ih) ? ih : iw //  
    }
    
    const src = img.src
    const orientation = getOrientation(src)

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    ctx.save();

    transformCoordinate(canvas, frameWidth, frameWidth, orientation);
    const subSampled = detectSubsampling(img);
    if (subSampled) {
        iw = iw / 2;
        ih = ih / 2;
    }
    const sx = (iw - ih) > 0 ? (iw - ih) / 2 : 0
    const sy = (ih - iw) > 0 ? (ih - iw) / 2 : 0
    const ww = (iw > ih) ? ih : iw

    //ctx.drawImage(img, sx, sy, iw, ih, 0, 0, frameWidth, frameWidth);
    ctx.drawImage(img, sx, sy, ww, ww, 0, 0, frameWidth, frameWidth);

    const displaySrc = ctx.canvas.toDataURL("image/jpeg", 0.9);

    return {src: displaySrc};
}

const loadImage = (width: number) => (file: File) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            let img = new Image();
            img.onload = () => {
                if (img.naturalWidth !== width || img.naturalHeight !== width) {
                    resolve(onResizeImage(img, width))
                } else {
                    resolve({
                        src: reader.result,
                    })
                }
                img = null;
            };
            img.onerror = evt => {
                reject(evt);
                img = null;
            };
            img.src = reader.result as string;
        };
        reader.onerror = reject
        reader.readAsDataURL(file);
    });
}

export interface ImageLoadInfo {
    file: File,
}
export type ImageLoaderParam = ImageLoadInfo 

export const makeImageLoaderDriver = (frameWidth = PHOTO_WIDTH) => {
    const source$ = xs.create()

    return (sink$: xs<ImageLoaderParam>) => {
        sink$
            .map(async (param: ImageLoaderParam) => {
                const {file} = param
                try {
                    const src = await loadImage(frameWidth)(file)
                    source$.shamefullySendNext(src);
                } catch (e) {
                    console.log(e)
                }
                return file
            })
            .addListener(nopListener("makeImageLoaderDriver"));
        return source$;
    };
}
